import Swal from 'sweetalert2'
import {
    IS_LOADING_SEND_MESSAGE, SEND_MESSAGE, CONVERSATION, IS_LOADING_SEND_MESSAGE_ROOM, IS_LOADING_CONVERSATION, SEND_MESSAGE_ROOM, IS_LOADING_CONVERSATION_ROOM, CONVERSATION_ROOM,
    IS_LOADING_CONVERSATIONS_LIST, CONVERSATIONS_LIST, NEW_MESSAGE, DELETE_CONVERSATION, NEW_MESSAGE_ROOM
} from './types'

import {
    urlServer
} from '../config/GlobalConstant'
import inMemoryJWT from '../auth/inMemoryJwt';
import localStorage from '../utils/hooks/useLocalStorage';

export const sendMessage = (message, history) => async dispatch => {

    await fetch(`${urlServer}chats/send-message`, {
        method: 'POST', 
        mode: 'cors', 
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            

        }, 
        body: message
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_SEND_MESSAGE
                });
                dispatch({
                    type: SEND_MESSAGE,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getConversation = (idUser, isProfessional) => async dispatch => {
    dispatch({
        type: IS_LOADING_CONVERSATION,
        payload: idUser
    })
    await fetch(`${urlServer}chats/get-conversation`, {
        method: 'POST', 
        mode: 'cors', 
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
        }, 
        body: JSON.stringify({

            addressee: idUser
        })
    })
        .then(response => response.json())
        .then(respJson => {
            var dataConversation = respJson.data.reverse() || {}
            var newData = new Date()
            if (respJson.success === true) {
                dispatch({
                    type: CONVERSATION,
                    payload: { dataConversation, idUser, dataReload: newData }
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const addMessage = (data, isProfessional, isIncoming, replyMenssage, storyData) => async dispatch => {


     dispatch(getConversationsList(isProfessional))
    var dataMsgContent = isIncoming ? data.bodyMessage : data
    if(replyMenssage){
        dataMsgContent.responseToMessageId = replyMenssage
    }
    

    if (data.from) {
        dataMsgContent.infoSender = data.from
    }

    if (storyData) {
        dataMsgContent.storyID = {}
        dataMsgContent.storyID.multimedia = []
        dataMsgContent.storyID.multimedia[0] = storyData  
    }

    dispatch({
        type: IS_LOADING_CONVERSATION,
        payload: data._id
    })

    dispatch({
        type: NEW_MESSAGE,
        payload: { dataMsgContent, isIncoming }
    }); 
}


export const addMessageRoom = (data) => async dispatch => {
    dispatch({
        type: IS_LOADING_CONVERSATION_ROOM
    })

    dispatch({
        type: NEW_MESSAGE_ROOM,
        payload: data
    });
}


export const sendMessageRoom = (messageRoom, history) => async dispatch => {

    await fetch(`${urlServer}chats/send-message-room`, {
        method: 'POST', 
        mode: 'cors', 
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
        }, 
        body: JSON.stringify(messageRoom)
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_SEND_MESSAGE_ROOM
                });
                dispatch({
                    type: SEND_MESSAGE_ROOM,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getConversationRoom = (chatRoomID) => async dispatch => {

    await fetch(`${urlServer}chats/get-messages-room`, {
        method: 'POST', 
        mode: 'cors', 
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
        }, 
        body: JSON.stringify({ chatRoomID })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_CONVERSATION_ROOM
                });
                dispatch({
                    type: CONVERSATION_ROOM,
                    payload: respJson.data.reverse()
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getConversationsList = (isProfessional, isAdmin = false) => async dispatch => {
    
    await fetch(`${urlServer}${(isAdmin ===true) ? 'chats/conversation-admin' : 'chats/get-conversation-list'}`, {
        method: 'POST', 
        mode: 'cors', 
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
        }, 
        body: JSON.stringify({ entityId: isProfessional ? localStorage().getItem('professionalID') : localStorage().getItem('idProfile') })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_CONVERSATIONS_LIST
                });
                dispatch({
                    type: CONVERSATIONS_LIST,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const viewConversation = (idConversation) => async dispatch => {

    await fetch(`${urlServer}chats/view-conversation`, {
        method: 'POST', 
        mode: 'cors', 
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
        }, 
        body: JSON.stringify({
            conversationId: idConversation
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
        })
        .catch(error => {
            console.log()
        })
}

export const deleteConversation = (id, index, isProfessional, conversationId) => async dispatch => {
    await fetch(`${urlServer}chats/delete-conversation`, {
        method: 'POST', 
        mode: 'cors', 
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
        }, 
        body: JSON.stringify({
            conversationId: id,
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_CONVERSATIONS_LIST
                });
                dispatch({
                    type: DELETE_CONVERSATION,
                    payload: {data: respJson.data, index}
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

